import API from '@aws-amplify/api';
export default {
  namespaced: true,
  state: {
    user: null,
    token: null
  },
  actions: {
    setUser(context, user) {
      if (!user && context.state.user) {
        //cancel for push notifciations
        if (window.messaging) {
          window.messaging.deleteToken(context.state.token).then(() => {
            context.commit('setToken', null);
          });
        }
      } else if (user && !context.state.user) {
        if (window.messaging) {
          window.messaging.getToken().then(function(token) {
            context.commit('setToken', token);

            API.post('ipWayAPI', '/notifications/register', {
              body: {
                deviceToken: token,
                platform: 'web'
              }
            }).then(reply => {
              console.log(
                'Register for push notification ends succesfully',
                reply
              );
            });
          });
        }
      }
      context.commit('setUser', user);
    }
  },
  mutations: {
    setUser(state, user) {
      console.log('Cognito user now is ', user);
      state.user = user;
    },
    setToken(state, token) {
      console.log('FCM token now is', token);
      state.token = token;
    }
  },
  getters: {
    user: state => {
      return state.user;
    }
  }
};
